import { useTranslation } from "react-i18next";
import SectionHead from "../../components/shared/SectionHead";
import ShowCard from "./ShowCard";
import { PROJECTS } from "./projects";

export default function Showcase() {
    const { t } = useTranslation("landing");

    return (
        <section
            id="showcase"
            className="scroll-mt-24 py-16 sm:py-20 lg:py-24"
        >
            <div className="mx-auto max-w-container px-5 sm:px-7">
                <SectionHead
                    eyebrow={t("showcase.eyebrow")}
                    title1={t("showcase.title1")}
                    titleGrad={t("showcase.titleGrad")}
                    subtitle={t("showcase.sub")}
                />

                {/* Grid — دسکتاپ: ۱۲ ستون / تبلت و موبایل: تک‌ستونه */}
                <div className="grid grid-cols-1 gap-4 sm:gap-5 lg:grid-cols-12 lg:grid-rows-2 lg:gap-5">
                    {PROJECTS.map((project, i) => (
                        <ShowCard key={project.key} project={project} index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}